export const AD_BANNER_CLIENTSIDE_HOOK = 'retailMedia_slot'
export const AD_BANNER_CLOSE_CLIENTSIDE_HOOK = 'bannerClose'
export const AD_BANNER_TOP_BANNER_DIMENSIONS = { width: 1920, height: 100 }
export const AD_BANNER_PARTNER_CODE_SEARCH_PARAM = 'partnercode'
export const AD_BANNER_ALLOWED_PARTNER_CODES = ['allianzcbp']
export const AD_BANNER_STATUS_DATA_ATTR = 'data-as-status'
export const AD_BANNER_TAGS_DATA_ATTR = 'data-as-tags'
export const AD_BANNER_CONTENT_DATA_ATTR = 'data-as-content'
export const AD_BANNER_WIDTH_DATA_ATTR = 'data-as-width'
export const AD_BANNER_HEIGHT_DATA_ATTR = 'data-as-height'
export const AD_BANNER_AUTO_LOAD_DATA_ATTR = 'data-auto-load'
